import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function myWaitListReducer(
  state = initialState.myWaitListData, 
  action
) {
  if (action.type === types.LOADED_MENTEE_WAITLIST_DATA) {
    return action.myWaitListData;
  }
  return state;
}
